import React, { useState } from "react";
import "./ImagesGalleryTestimonial.css";
import Lightbox from "react-image-lightbox"; // Install with `npm install react-image-lightbox`
import "react-image-lightbox/style.css";
import im1 from "../../assets/images/im1.jpg";
import im2 from "../../assets/images/im2.jpg";
import im3 from "../../assets/images/im3.jpg";
import im4 from "../../assets/images/im4.jpg";
import im5 from '../../assets/images/im5.jpg';
import im6 from '../../assets/images/im6.jpg';
import im7 from '../../assets/images/im7.jpg';
import im8 from '../../assets/images/im8.jpg';
import im9 from '../../assets/images/im9.jpg';

const images = [
  {
    src: im1,
    title: "Port Expansion - ABC Ltd.",
    description: "Completed port expansion project for ABC Ltd. in 2023.",
  },
  {
    src: im2,
    title: "Environmental Compliance",
    description: "Achieved compliance for XYZ Ltd. in 2022.",
  },
  {
    src: im3,
    title: "Fire Safety Compliance",
    description: "Fire safety approvals for DEF Corp. in 2023.",
  },
  {
    src: im4,
    title: "Dockyard Construction",
    description: "Construction of new dockyard facilities for MNO Pvt Ltd.",
  },
  {
    src: im5,
    title: "Environmental Compliance",
    description: "Achieved compliance for XYZ Ltd. in 2022.",
  },
  {
    src: im6,
    title: "Fire Safety Compliance",
    description: "Fire safety approvals for DEF Corp. in 2023.",
  },
  {
    src: im7,
    title: "Dockyard Construction",
    description: "Construction of new dockyard facilities for MNO Pvt Ltd.",
  },
  {
    src: im8,
    title: "Renewable Energy Setup",
    description: "Solar panel installation for Green Energy Solutions, 2023.",
  },
  {
    src: im9,
    title: "Highway Bridge Construction",
    description: "Engineered and constructed a 5km bridge for Urban Connect in 2022.",
  }
];

export default function ImagesGalleryTestimonial() {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  return (
    <section className="image-gallery">
      <h2 className="gallery-title">Our Projects and Collaborations</h2>
      <div className="gallery-grid">
        {images.map((image, index) => (
          <div
            key={index}
            className="gallery-item"
            onClick={() => {
              setPhotoIndex(index);
              setLightboxOpen(true);
            }}
          >
            <img src={image.src} alt={image.title} className="gallery-image" />
            <div className="image-description">
              <h3>{image.title}</h3>
              <p>{image.description}</p>
            </div>
          </div>
        ))}
      </div>

      {lightboxOpen && (
        <Lightbox
          mainSrc={images[photoIndex].src}
          nextSrc={images[(photoIndex + 1) % images.length].src}
          prevSrc={images[(photoIndex + images.length - 1) % images.length].src}
          onCloseRequest={() => setLightboxOpen(false)}
          onMovePrevRequest={() =>
            setPhotoIndex((photoIndex + images.length - 1) % images.length)
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % images.length)
          }
          imageCaption={`${images[photoIndex].title} - ${images[photoIndex].description}`}
        />
      )}
    </section>
  );
}
